import axios from 'axios'
import {router} from '../router';
import { Message } from 'element-ui'
import { getUser,getAuthToken, getMenuList ,isSuperUser } from '@/assets/js/user';
axios.defaults.withCredentials = true
axios.defaults.timeout = 60000
axios.defaults.headers.post['Content-Type'] = 'application/json'
//axios.defaults.baseURL = "https://admin.aladdins.finance/api";
axios.defaults.baseURL = "https://admin.ceresdao.finance/api/";
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (getAuthToken()) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = getAuthToken()
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT)
          router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } });
          Message.error('登录已经过期，请重新登录')
          break
        case 403:
          // console.log(error.response)
          Message.error('无此操作权限，请联系管理员!');
          break;
        case 404:
          Message.error('404:Service Not Found');
          break
        case 500:
          Message.error('500:Internal Server Error');
          break
      }
    }
    // 返回接口返回的错误信息
    // if (error.response.headers['content-type'].indexOf('application/json') === -1) {
    //   return false
    // }
    // return Promise.reject(error.response.data)
  }
)
export const http = {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params: params }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchQuickSearch(url) {
    return new Promise((resolve, reject) => {
      axios.get(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        resolve(res.data);
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPut(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.put(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

/**
 * 格式化URL,针对 pathParam
 */
export const formatURI = (url, ...args) => {
  return url.replace(/\{(\d+)\}/g, (c, index) => {
    if (args[index] === null) {
      return ''
    } else {
      if (typeof args[index] === 'string') {
        return args[index].encodeURI()
      } else {
        return args[index]
      }
    }
  })
}
